import { useRef, useCallback, useEffect } from 'react';

import { useVirtual } from 'react-virtual';

import { RowVirtualizer, UseVirtualizedHelpersProps } from '../types';

type VirtualizedHelpers = {
  parentRef: React.RefObject<HTMLDivElement>;
  rowVirtualizer: RowVirtualizer;
};

const useVirtualizedHelpers = ({
  menuItems,
  isGroupHeader,
  isOpen,
}: UseVirtualizedHelpersProps): VirtualizedHelpers => {
  const parentRef = useRef<HTMLDivElement>(null);
  const rowVirtualizer = useVirtual({
    size: menuItems.length,
    parentRef,
    overscan: 10,
    estimateSize: useCallback(
      (index: number) => {
        const item = menuItems[index];

        return isGroupHeader(item)
          ? item.label
            ? 32
            : 0
          : item.subtext
            ? 56
            : 36;
      },
      [menuItems, isGroupHeader],
    ),
  });

  useEffect(() => {
    if (!isOpen) {
      rowVirtualizer.scrollToOffset(0);
    }
  }, [isOpen, rowVirtualizer]);

  return { parentRef, rowVirtualizer };
};

export default useVirtualizedHelpers;
